import React, { useEffect, useRef } from "react";
import api from "../../../api/api";
import { toast } from "react-toastify";
import { useTranslation } from "../../../hooks/useTranslation";
import { CALLBACKS, triggerCallback } from "../../../utils/commonUtils";
import { useCheckout } from "../../../context/CheckoutContext";
import { useIframeResize } from "../../../hooks/useIframeResize";
import { getShopperCitFailureMessage } from "../../../utils/paymentOutcome";
import AdyenCardForm from "./AdyenCardForm";

const AltruonAdyenCardForm = ({
  formData,
  itemDetails,
  billingPlatformId,
  routingEntries,
  planId,
  platformItemDetails,
  checkoutPageConfDto,
  checkoutProcessDto,
  transparent,
  prefetchedGatewayConnection,
  tenantId,
}) => {
  const queryParams = new URLSearchParams(window.location.search);
  const sessionId = queryParams.get("session_id");
  const { triggerPaymentEvent } = useCheckout();
  const { t } = useTranslation();

  useIframeResize({ enabled: true, padding: 40 });

  /**
   * 🔹 Parent → Child message listener
   */
  useEffect(() => {
    const handler = (event) => {
      if (event.data?.type === "makePayment") {
        triggerPaymentEvent();
      }
    };
    window.addEventListener("message", handler);
    return () => window.removeEventListener("message", handler);
  }, [triggerPaymentEvent]);

  /**
   * 🔹 Card data changes → Notify parent like Checkout.com version
   */
  const handleCardDataChange = (cardData) => {
    window.parent.postMessage(
      {
        type: "updateCardData",
        data: {
          holderName: cardData?.holderName,
        },
      },
      "*"
    );
  };

  const onParentCallback = (event) => {
    switch (event.type) {
      case "finalizeFormData":
        window.parent.postMessage(event, "*");
        break;

      case "actionRequired":
        triggerCallback(CALLBACKS.ACTION_REQUIRED, {
          actionType: "REDIRECT",
          redirectUrl: event.url,
          message: "Payment initiated, redirecting you to complete the process...",
        });
        break;

      case "success":
        triggerCallback(CALLBACKS.SUCCESS, {
          status: "success",
          transactionId: event.transactionId,
          message: "Payment successfully initiated.",
        });

        //Notify parent window that payment is successful
        window.parent.postMessage(
          {
            type: "paymentSuccess",
            data: { transactionId: event.transactionId },
          },
          "*"
        );
        break;

      default:
        triggerCallback(CALLBACKS.FAILURE, {
          status: "failed",
          message: getShopperCitFailureMessage(t),
        });
    }
  };

  return (
    <AdyenCardForm
      formData={formData}
      itemDetails={itemDetails}
      billingPlatformId={billingPlatformId}
      routingEntries={routingEntries}
      planId={planId}
      platformItemDetails={platformItemDetails}
      checkoutPageConfDto={checkoutPageConfDto}
      checkoutProcessDto={checkoutProcessDto}
      sessionId={sessionId}
      transparent={transparent}
      prefetchedGatewayConnection={prefetchedGatewayConnection}
      tenantId={tenantId}
      onCardDataChange={handleCardDataChange}
      onParentCallback={onParentCallback}
      isEmbeddedCheckout={true}
    />
  );
};

export default AltruonAdyenCardForm;
